"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = clearCsrf;
function clearCsrf(req, res, next) {
    req.session.csrfToken = undefined;
    res.clearCookie('_csrf');
    next();
}
